<template>
  <div class="supplierEnterpriseInfo_box">
    <Form ref="supplierEnterpriseInfoForm" :rules="supplierEntryInfoValidate" :model="supplierEnterpriseInfoForm"
      :label-width="160" autocomplete="off" @submit.native.prevent>
      <!--企业信息-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002793') }}</h2>
        </template>
        <div class="form_box">
          <Row style="width: 560px;" class="mt20" type="flex" justify="center">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002682')" prop="name">
                <Input v-model.trim="supplierEnterpriseInfoForm.name" size="large"
                  :placeholder="$t('key1006499')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002766')" prop="businessLicensePath" class="required_style_label">
                <div class="flex align-items-end">
                  <Upload
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="(file)=>handleBeforeUpload(file, 'businessLicensePath')"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'businessLicensePath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="(file)=>handleFormatError(file, 'businessLicensePath')"
                    :on-exceeded-size="(file)=>handleMaxSize(file, 'businessLicensePath')">
                    <div class="img_style" v-if="picturesObj.businessLicensePath">
                      <img :src="picturesObj.businessLicensePath" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #FE5426"></Icon>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                  <span class="distributorThemeColor cursor ml30"
                    @click="viewSpecificationsBtn('businessLicense')">{{ $t('key1000963') }}</span>
                </div>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002767')" class="required_style_label">
                <div class="flex align-items-end">
                  <Upload
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="(file)=>handleBeforeUpload(file, 'identificationCardPath')"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="(file)=>handleFormatError(file, 'identificationCardPath')"
                    :on-exceeded-size="(file)=>handleMaxSize(file, 'identificationCardPath')">
                    <div class="img_style" v-if="picturesObj.identificationCardPath">
                      <img :src="picturesObj.identificationCardPath" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #FE5426"></Icon>
                      <p>{{ $t('key1002795') }}</p>
                    </div>
                  </Upload>
                  <Upload
                    class="upload_styles ml20"
                    ref="upload"
                    type="drag"
                    name="files"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="(file)=>handleBeforeUpload(file, 'identificationCardBackPath')"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardBackPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="(file)=>handleFormatError(file, 'identificationCardBackPath')"
                    :on-exceeded-size="(file)=>handleMaxSize(file, 'identificationCardBackPath')">
                    <div class="img_style" v-if="picturesObj.identificationCardBackPath">
                      <img :src="picturesObj.identificationCardBackPath" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #FE5426"></Icon>
                      <p>{{ $t('key1002796') }}</p>
                    </div>
                  </Upload>
                  <span class="distributorThemeColor cursor ml30"
                    @click="viewSpecificationsBtn('legalRepresentative')">{{ $t('key1000963') }}</span>
                </div>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002768')" prop="scale">
                <Select v-model="supplierEnterpriseInfoForm.scale" transfer filterable size="large"
                  :placeholder="$t('key1000101')">
                  <Option v-for="item in scaleList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002769')" prop="contacts">
                <Input v-model.trim="supplierEnterpriseInfoForm.contacts" size="large" :placeholder="$t('key1002770')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002771')" prop="contactsPhone">
                <Input v-model.trim="supplierEnterpriseInfoForm.contactsPhone" size="large"
                  :placeholder="$t('key1002772')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001175')" prop="phone">
                <Input v-model.trim="supplierEnterpriseInfoForm.phone" size="large" :placeholder="$t('key1002773')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1000068')" prop="email">
                <Input v-model.trim="supplierEnterpriseInfoForm.email" size="large" :placeholder="$t('key1002765')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </div>
      </Card>
      <!--店铺信息-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002797') }}</h2>
        </template>
        <div class="form_box">
          <Row style="width: 560px;" class="mt20" type="flex" justify="center">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002774')" prop="shopName">
                <Input v-model.trim="supplierEnterpriseInfoForm.shopName" size="large" :placeholder="$t('key1002775')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002776')" prop="shopLogoPath" class="required_style_label">
                <div class="flex align-items-end">
                  <Upload
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="(file)=>handleBeforeUpload(file, 'shopLogoPath')"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'shopLogoPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="(file)=>handleFormatError(file, 'shopLogoPath')"
                    :on-exceeded-size="(file)=>handleMaxSize(file, 'shopLogoPath')">
                    <div class="img_style" v-if="picturesObj.shopLogoPath">
                      <img :src="picturesObj.shopLogoPath" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #FE5426"></Icon>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                </div>
                <p class="font-size-12">{{ $t('key1002798') }}</p>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002777')" prop="managementModel">
                <Select v-model="supplierEnterpriseInfoForm.managementModel" transfer size="large" :placeholder="$t('key1000101')">
                  <Option v-for="item in managementModelList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002778')" prop="plannedBusinessCategory">
                <Select v-model="supplierEnterpriseInfoForm.plannedBusinessCategory" transfer size="large"
                  :placeholder="$t('key1000101')" multiple>
                  <Option v-for="item in plannedBusinessCategoryList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002779')" prop="shelvesProductsNumber">
                <Select v-model="supplierEnterpriseInfoForm.shelvesProductsNumber" transfer size="large" :placeholder="$t('key1000101')">
                  <Option v-for="item in groundingList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
              v-show="supplierEnterpriseInfoForm.productReleaseRate ===0">
              <FormItem :label="$t('key1002780')" prop="productReleaseRate" class="reset_input_styles required_style_label">
                <Select v-model="supplierEnterpriseInfoForm.productReleaseRate" size="large" :placeholder="$t('key1000101')">
                  <Option v-for="item in releaseTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
              v-show="supplierEnterpriseInfoForm.productReleaseRate !==0">
              <FormItem :label="$t('key1002780')" prop="productReleaseNumber" class="reset_input_styles">
                <Input v-model.trim="supplierEnterpriseInfoForm.productReleaseNumber" size="large"
                  :placeholder="$t('key1002781')" clearable style="width:100%">
                  <Select v-model="supplierEnterpriseInfoForm.productReleaseRate" slot="prepend" style="width: 110px"
                    :placeholder="$t('key1000101')">
                    <Option v-for="item in releaseTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                  </Select>
                  <span slot="append">{{ $t('key1002749') }}</span>
                </Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002782')" prop="businessAddress">
                <Cascader
                  size="large"
                  v-model="supplierEnterpriseInfoForm.businessAddress"
                  :data="businessAddressData"
                  filterable
                  change-on-select>
                </Cascader>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="address">
                <Input v-model.trim="supplierEnterpriseInfoForm.address" size="large" :placeholder="$t('key1002783')"
                  clearable style="width:100%">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" style="width: 400px; margin-left: 160px;">
            <Button type="primary" style="width: 100%" @click="nextStepBtn" size="large">{{ $t('key1002560') }}</Button>
          </Row>
        </div>
      </Card>
    </Form>
    <viewSpecificationsModal ref="viewSpecifications"></viewSpecificationsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import viewSpecificationsModal from "@/views/shopping/login/components/viewSpecificationsModal.vue";
import {getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "supplierEnterpriseInfo",
  mixins: [Mixin],
  props: {
    supplierInfo: { // 供应商基本信息
      type: Object,
      default: () => {
      }
    },
    supplierEnterpriseType: { // 标识当前是新增还是重新编辑状态
      type: String,
      default: 'add' // 默认是新增
    }
  },
  data() {
    let v = this;
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      supplierEnterpriseInfoForm: {
        name: '', // 公司名称
        businessLicensePath: null, // 营业执照
        identificationCardBackPath: null, // 法人身份证国徽面
        identificationCardPath: null, // 法人身份证人像面
        scale: null, // 经营规模:1.10人以下、2.10~30人、3.30~50人、4.50~100人、5.100人以上
        contacts: '', // 联系人
        contactsPhone: '', // 联系人手机号码
        phone: '', // 固定电话
        email: '', // 邮箱
        shopName: '', // 店铺名称
        shopLogoPath: null, // 店铺logo
        managementModel: null, // 经营模式 1.自有工厂、2.渠道代理、3.经销批发
        plannedBusinessCategory: [], //  类目:1.经营类目  类目值:1.女装、2.男装、3.男童、4.女童、5.婴童
        shelvesProductsNumber: null, // 预计上架商品数  1.10以下 2.10~30 3.30~50 4.50~100 5.100以上
        productReleaseRate: null, // 商品发布频率:0.待定、1.每天发布、2.每周发布、3.每月发布
        productReleaseNumber: null, // 商品发布数
        businessAddress: [], // 营业地址
        address: '', // 详细地址
      },
      supplierEntryInfoValidate: {
        name: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006492'), trigger: 'blur'}],
        scale: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002728'), trigger: 'change', type: 'number'}],
        contacts: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002729'), trigger: 'blur'}],
        contactsPhone: [{required: true, validator: v.validateMobile(), trigger: 'blur'}],
        phone: [{required: false, validator: v.validateFixedTelephone(), trigger: 'blur'}],
        email: [{validator: v.validateMailboxFormat(false), required: false, trigger: 'blur'}],
        shopName: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002730'), trigger: 'blur'}],
        managementModel: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002731'), trigger: 'change', type: 'number'}],
        plannedBusinessCategory: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002732'), trigger: 'change', type: 'array'}],
        shelvesProductsNumber: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002733'), trigger: 'change', type: 'number'}],
        productReleaseNumber: [{required: true, validator: v.validatePositiveInteger(), trigger: 'blur'}],
        businessAddress: [{required: true, validator: v.validateCascaderValue(), trigger: 'change'}],
        address: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001156'), trigger: 'blur'}],
      },
      scaleList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002735')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002736')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002737')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002738')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002739')}
      ], // 经营规模
      groundingList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002740')},
        {value: 2, name: '10~30'},
        {value: 3, name: '30~50'},
        {value: 4, name: '50~100'},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002741')}
      ], // 预计上架商品数
      businessAddressData: [],
      ymsMerchantStoreAttributes: [],
      ymsMerchantStoreAddressId: null,
      ymsMerchantStoreId: null,
      uploadList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002751'), key: 'businessLicensePath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006493'), key: 'identificationCardBackPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006494'), key: 'identificationCardPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002754'), key: 'shopLogoPath'},
      ],
      picturesObj: {
        businessLicensePath: null,
        identificationCardBackPath: null,
        identificationCardPath: null,
        shopLogoPath: null
      },
      enumData: []
    };
  },
  computed: {
    // 经营模式
    managementModelList() {
      const ENUM_KEY = 'YmsMerchantStoreManagementModelCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 发布类型
    releaseTypeList() {
      const ENUM_KEY = 'YmsMerchantStoreProductReleaseRateCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 计划经营类目
    plannedBusinessCategoryList() {
      const ENUM_KEY = 'YmsMerchantStoreAttributeAttributeValueCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = [
          'YmsMerchantStoreManagementModelCoreEnum',
          'YmsMerchantStoreProductReleaseRateCoreEnum',
          'YmsMerchantStoreAttributeAttributeValueCoreEnum'
        ];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await v.getProvinceBasicData('CN').then((list) => {
          if (list.length > 0) {
            v.businessAddressData = list;
          }
        });
        v.$nextTick(() => {
          v.$refs['supplierEnterpriseInfoForm'].resetFields();
        });
      })();
    },
    // 上传图片之前 (营业执照、法人身份证、店铺logo)
    handleBeforeUpload(file, type) {
      let v = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result;
          v.uploadList.map((item) => {
            if (item.key === type) {
              v.picturesObj[type] = base64Data;
              v.$forceUpdate();
            }
          });
          resolve(file);
        };
        // 读取文件内容，并将其转换为 Base64 编码数据
        reader.readAsDataURL(file);
      });
    },
    // （营业执照、法人身份证、店铺logo）--上传成功
    uploadSuccess(response, file, fileList, type) {
      let v = this;
      v.uploadList.map((item) => {
        if (item.key === type) {
          if (response.code === 0) {
            v.supplierEnterpriseInfoForm[item.key] = response.datas[0];
            v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
            v.$forceUpdate();
          } else {
            v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
          }
        }
      });
    },
    // 校验文件格式
    handleFormatError(file, type) {
      let v = this;
      v.picturesObj[type] = null;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006491')}`,
        duration: 5
      });
      v.$forceUpdate();
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file, type) {
      let v = this;
      v.picturesObj[type] = null;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
      v.$forceUpdate();
    },
    // 下一步
    nextStepBtn() {
      let v = this;

      function validateForm(obj) {
        let talg = true;
        // 校验上传的图片
        let uloadImgList = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002755'), key: 'businessLicensePath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006495'), key: 'identificationCardBackPath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006496'), key: 'identificationCardPath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002758'), key: 'shopLogoPath'},
        ];
        for (let i = 0; i < uloadImgList.length; i++) {
          let item = uloadImgList[i];
          if (!obj[item.key]) {
            talg = false;
            v.$Message.warning(item.title);
            return false;
          }
        }
        if (obj.productReleaseRate === null) {
          talg = false;
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002759'));
          return false;
        }
        return talg;
      }

      v.$refs['supplierEnterpriseInfoForm'].validate((valid) => {
        if (valid) {
          if (validateForm(v.supplierEnterpriseInfoForm)) {
            let params = {
              businessLicensePath: v.supplierEnterpriseInfoForm.businessLicensePath, // 营业执照
              contacts: v.supplierEnterpriseInfoForm.contacts, // 联系人
              contactsPhone: v.supplierEnterpriseInfoForm.contactsPhone, // 联系人手机号码
              email: v.supplierEnterpriseInfoForm.email, // 邮箱
              identificationCardBackPath: v.supplierEnterpriseInfoForm.identificationCardBackPath, // 法人身份证国徽面
              identificationCardPath: v.supplierEnterpriseInfoForm.identificationCardPath, // 法人身份证人像面
              name: v.supplierEnterpriseInfoForm.name, // 公司名称
              phone: v.supplierEnterpriseInfoForm.phone, // 固定电话
              scale: v.supplierEnterpriseInfoForm.scale, // 经营规模:1.10人以下、2.10~30人、3.30~50人、4.50~100人、5.100人以上
              ymsMerchantId: v.supplierInfo.ymsMerchantId, // 商户号
              updateYmsMerchantStoreBo: {
                managementModel: v.supplierEnterpriseInfoForm.managementModel, // 经营模式:1.自有工厂、2.渠道代理、3.经销批发
                name: v.supplierEnterpriseInfoForm.shopName, // 店铺名称
                productReleaseNumber: v.supplierEnterpriseInfoForm.productReleaseRate !== 0 ? v.supplierEnterpriseInfoForm.productReleaseNumber : null, // 商品发布数
                productReleaseRate: v.supplierEnterpriseInfoForm.productReleaseRate, // 商品发布频率:0.待定、1.每天发布、2.每周发布、3.每月发布
                shelvesProductsNumber: v.supplierEnterpriseInfoForm.shelvesProductsNumber, // 预计上架商品数
                shopLogoPath: v.supplierEnterpriseInfoForm.shopLogoPath, // 店铺logo
                supplierMerchantId: v.supplierInfo.ymsMerchantId,
                updateYmsMerchantStoreAddressBos: [
                  {
                    city: v.supplierEnterpriseInfoForm.businessAddress[1], // 城市
                    countryCode: 'CN', // 国家或地区二字码
                    district: v.supplierEnterpriseInfoForm.businessAddress[2], // 区域
                    state: v.supplierEnterpriseInfoForm.businessAddress[0], // 省/州
                    street: v.supplierEnterpriseInfoForm.address,
                    ymsMerchantStoreAddressId: v.ymsMerchantStoreAddressId || null,
                  }
                ],
                updateYmsMerchantStoreAttributeBos: [],
                ymsMerchantStoreId: v.ymsMerchantStoreId || null
              }
            };
            v.supplierEnterpriseInfoForm.plannedBusinessCategory.map((item) => {
              let ymsMerchantStoreAttributeId = null;
              if (v.ymsMerchantStoreAttributes.length > 0) {
                v.ymsMerchantStoreAttributes.map((ele) => {
                  if (item === ele.attributeValue) {
                    ymsMerchantStoreAttributeId = ele.ymsMerchantStoreAttributeId;
                  }
                });
              }
              params.updateYmsMerchantStoreBo.updateYmsMerchantStoreAttributeBos.push({
                attributeId: 1, // 类目:1.经营类目
                attributeValue: item, // 类目值:1.女装、2.男装、3.男童、4.女童、5.婴童
                ymsMerchantStoreAttributeId: ymsMerchantStoreAttributeId,
              });
            });
            v.axios.post(api.post_ymsSupplierMerchant_updateSupplierMerchantInfo, params, {loading: true}).then(response => {
              if (response.data.code === 0) {
                v.$emit('submittedSuccess', 2);
              }
            });
          }
        }
      });
    },
    // 查看规范
    viewSpecificationsBtn(type) {
      let obj = {
        legalRepresentative: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006497'),
        businessLicense: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006498')
      };
      this.$refs['viewSpecifications'].initViewSpecificationsData(type, obj[type]);
    },
    // 校验商品发布的具体数量
    validatePositiveInteger() {
      let v = this;
      let reg = v.$regular.positiveInteger;
      return function (rule, value, callback) {
        if (v.supplierEnterpriseInfoForm.productReleaseRate !== 0) {
          if (!value) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002761')));
          } else {
            const number = Number(value);
            if (!reg.test(number)) {
              callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002762')));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      };
    },
    // 校验营业地址
    validateCascaderValue() {
      return function (rule, value, callback) {
        if (!value || value.length <= 0) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002763')));
        } else {
          if (value.length < 3) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002764')));
          } else {
            callback();
          }
        }
      };
    },
    // 获取企业信息详情数据
    getSupplierEnterpriseInfoData() {
      let v = this;
      v.supplierEnterpriseInfoForm.plannedBusinessCategory = [];
      v.ymsMerchantStoreAddressId = null;
      v.ymsMerchantStoreId = null;
      v.ymsMerchantStoreAttributes = [];
      v.picturesObj = {};
      if (Object.keys(v.supplierInfo).length > 0) {
        let keyList = ['name', 'scale', 'contacts', 'contactsPhone', 'phone', 'email'];
        let imgKeyList = ['businessLicensePath', 'identificationCardBackPath', 'identificationCardPath'];
        let storeskeyList = ['shopLogoPath', 'managementModel', 'shelvesProductsNumber', 'productReleaseRate', 'productReleaseNumber'];
        let ymsMerchantStores = v.supplierInfo.ymsMerchantStores || [];
        for (let key in v.supplierEnterpriseInfoForm) {
          if (keyList.includes(key)) {
            v.supplierEnterpriseInfoForm[key] = v.supplierInfo[key];
          }
          if (imgKeyList.includes(key)) {
            v.picturesObj[key] = v.supplierInfo[key];
            v.supplierEnterpriseInfoForm[key] = v.supplierInfo[key];
          }
          if (ymsMerchantStores.length > 0) {
            if (storeskeyList.includes(key)) {
              v.supplierEnterpriseInfoForm[key] = ymsMerchantStores[0][key];
            }
            v.ymsMerchantStoreId = ymsMerchantStores[0].ymsMerchantStoreId;
            v.supplierEnterpriseInfoForm.shopName = ymsMerchantStores[0].name;
            v.picturesObj['shopLogoPath'] = ymsMerchantStores[0].shopLogoPath;
            v.supplierEnterpriseInfoForm.shopLogoPath = ymsMerchantStores[0].shopLogoPath;
            v.ymsMerchantStoreAttributes = ymsMerchantStores[0].ymsMerchantStoreAttributes || [];
            let newList = [];
            if (v.ymsMerchantStoreAttributes.length > 0) {
              v.ymsMerchantStoreAttributes.map((item) => {
                newList.push(item.attributeValue);
              });
              v.supplierEnterpriseInfoForm.plannedBusinessCategory = v.uniqueFunc(newList);
            }
            v.supplierEnterpriseInfoForm.businessAddress = [];
            let ymsMerchantStoreAddresses = ymsMerchantStores[0].ymsMerchantStoreAddresses || [];
            if (ymsMerchantStoreAddresses.length > 0) {
              let obj = ymsMerchantStoreAddresses[0];
              v.supplierEnterpriseInfoForm.address = obj.street;
              v.ymsMerchantStoreAddressId = obj.ymsMerchantStoreAddressId;
              v.supplierEnterpriseInfoForm.businessAddress = [obj.state, obj.city, obj.district];
              v.$forceUpdate();
            }
          }
        }
      }
    }
  },
  watch: {
    supplierEnterpriseType: {
      handler(val) {
        if (val === 'edit') {
          this.getSupplierEnterpriseInfoData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    viewSpecificationsModal
  }
};
</script>

<style lang="less" scoped>
.supplierEnterpriseInfo_box {
  width: 1200px;
  margin: 40px auto;

  /deep/ .ivu-form-item-label {
    padding-right: 0 !important;
    font-size: 14px;
  }

  /deep/ .ivu-input-group-prepend {
    font-size: 13px;
    padding: 6px 20px;
  }

  /deep/ .ivu-input, /deep/ .ivu-select-input {
    font-size: 14px;
  }

  /deep/ .ivu-select-large.ivu-select-multiple .ivu-tag {
    font-size: 14px;
  }

  /deep/ .ivu-select-selected-value {
    font-size: 14px !important;
  }

  .title_box {
    font-size: 17px;
    font-weight: bold;
    color: #000;
  }

  .form_box {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .upload_styles {
      /deep/ .ivu-upload.ivu-upload-drag {
        width: 110px;
        height: 110px;
      }

      .upload_icon_box {
        width: 110px;
        height: 110px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
      }

      .img_style {
        width: 110px;
        height: 110px;
        display: flex;
        align-items: flex-start;
        justify-content: center;

        img {
          width: 100%;
          max-width: 110px;
          height: auto;
          display: inline-block;
        }
      }
    }

    .reset_input_styles {
      /deep/ .ivu-input-group-prepend {
        font-size: 13px;
        padding: 0 8px 0 8px !important;
        background-color: transparent;
        text-align: left;
      }

      /deep/ .ivu-input-group-append {
        font-size: 13px;
        padding: 0 10px 0 10px !important;
        background-color: transparent;
      }
    }

  }
}
</style>